module.exports = __webpack_public_path__ + "static/media/KPI.9cad0e0e.svg";